import React from "react";

const ContactMe = () => {
  return (
    <section id="contact-me" className="block spacer p-top-xl">
      <div className="wrapper">
        <div className="row gutter-width-md with-pb-md">
          <div className="col-sm-8 col-md-8 col-lg-7 col-xl-7 align-self-center">
            <div className="title">
              <h2>You can contact me through Bark or by email.</h2>
            </div>

            {/* <div className="description max-width-1">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
              </p>
            </div> */}

            <div className="description max-width-1 spacer m-top-lg no-space">
              <a
                className="btn btn-link btn-line p-0 border-0 min-w-auto text-uppercase before"
                href="https://www.bark.com/en/gb/company/daniel-haddon-photography/KL8LO/"
              >
                Bark Profile
              </a>
            </div>
            <div className="description max-width-1 spacer m-top-lg no-space">
              <a
                className="btn btn-link btn-line p-0 border-0 min-w-auto text-uppercase before"
                href="mailto:weddings@danielhaddon.com"
              >
                Photo@DanielHaddon.com
              </a>
            </div>
          </div>

          <div className="col-sm-4 col-md-4 col-lg-5 col-xl-5">
            <div className="img-size-1">
              <img src="assets/img/demo/Camera.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMe;
